var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-slider',{attrs:{"title":"Scale","percent":false,"min":0,"max":5,"precision":1},model:{value:(_vm.scale),callback:function ($$v) {_vm.scale=$$v},expression:"scale"}})}
var staticRenderFns = []

export { render, staticRenderFns }